// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    MAGAZINE_ARCHIVE_PAGE_LOADING() {
      return {
        isLoading: true,
        magazineArchivePage: action.magazineArchivePage
      };
    },
    MAGAZINE_ARCHIVE_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const tag = get(currentState, 'tagFeaturedFeed.tag');
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        tag,
        'magazineArchivePage'
      );

      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    MAGAZINE_ARCHIVE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.magazineArchivePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
